import HotkeyField from './HotkeyField.jsx';

export default HotkeyField;
